import { SafeUrl } from "@angular/platform-browser";

export enum NavServices {
    CA = 'Admin',
    REP = 'Reportería',
    BI = 'Analítica',
    CW = 'Colectiva Web',
    CM = 'Comunicación',
    ROUTES = 'Rutas'
} 

export interface NavUserProfileOption{
    title:string;
    route:any;
    icon?:string;
}

export interface NavEnvironment {
    repUrl: string;
    colUrl: string;
    biUrl: string;
    itUrl: string;
    comUrl: string;
    routesUrl: string;
    current:NavServices;
    logout: string;
}


export interface NavServicesMap {
    service:NavServices;
    key:string;
    url?:SafeUrl;
    current?:boolean;
}

export const NAV_MAPPED_SERVICES:NavServicesMap[]=[
    {
        service:NavServices.CA,
        key:'colUrl'
    },
    {
        service:NavServices.REP,
        key:'repUrl'
    },
    {
        service:NavServices.BI,
        key:'biUrl'
    },
    {
        service:NavServices.CW,
        key:'itUrl'
    },
    {
        service:NavServices.CM,
        key:'comUrl'
    },
    { 
        service: NavServices.ROUTES,
        key: 'routesUrl'
    }
]

export const NAV_SERVICES_BY_ROLE={
    cliente:[NavServices.CA,NavServices.REP,NavServices.BI,NavServices.CM, NavServices.ROUTES],
    subcliente:[NavServices.CA,NavServices.REP,NavServices.BI,NavServices.CM,NavServices.ROUTES],
    analista:[NavServices.CA,NavServices.REP,NavServices.BI],
    profesional:[NavServices.CW,NavServices.CM],
    productor:[NavServices.CW]
}